/**
 * 预筛选错误分类和类型定义
 * 基于"最小打扰"设计原则，将后端技术错误映射到用户友好的分类
 *
 * @see Requirements 4.1, 4.2, 4.3
 */

/**
 * 预筛选错误分类枚举
 * 将后端返回的技术 reason 映射到用户友好的分类
 */
export enum PrescreenErrorCategory {
  /** 非鱼类图片 - 必须提示 */
  NOT_FISH = "not_fish",
  /** 图片模糊 - 必须提示 */
  BLURRY = "blurry",
  /** 人工图片（截图/AI生成）- 必须提示 */
  ARTIFICIAL = "artificial",
  /** 光线问题 - 必须提示 */
  LIGHTING = "lighting",
  /** 文件过大 - 必须提示 */
  FILE_TOO_LARGE = "file_too_large",
  /** 图片格式无法识别 - 合并后的通用错误 */
  INVALID_FORMAT = "invalid_format",
  /** 图片读取失败 - 合并后的通用错误 */
  LOAD_FAILED = "load_failed",
}

/**
 * 预筛选错误消息结构
 */
export interface PrescreenErrorMessage {
  /** 错误标题 */
  title: string;
  /** 错误描述 */
  description: string;
  /** 操作提示（如"请重新拍摄"）*/
  actionHint: string;
  /** 图标类型 */
  iconType: "warning" | "error" | "info";
  /** 是否可以通过重试解决（false 表示需要重新选择图片）*/
  canRetry: boolean;
}

/**
 * 预筛选错误状态
 * 用于组件状态管理
 */
export interface PrescreenErrorState {
  /** 是否显示错误 */
  visible: boolean;
  /** 错误分类 */
  category: PrescreenErrorCategory | null;
  /** 错误消息 */
  message: PrescreenErrorMessage | null;
}

/**
 * Soft Pass 状态
 * 用于低置信度但放行的情况
 */
export interface SoftPassState {
  /** 是否显示角标 */
  visible: boolean;
  /** 提示消息 */
  tooltipMessage: string;
}
